module.exports = __webpack_public_path__ + "assets/img/4.a978cde8.png";